import { render, staticRenderFns } from "./point.vue?vue&type=template&id=f679b144"
import script from "./point.vue?vue&type=script&lang=js"
export * from "./point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports